import React from 'react';
import { Link } from 'react-router-dom';
import './ToolCard.css';

const ToolCard = ({ tool }) => {
  return (
    <Link to={tool.path} className="tool-card">
      <div className="tool-card-header">
        <h3 className="tool-card-title">{tool.name}</h3>
        <span className="tool-card-category">{tool.category}</span>
      </div>
      <p className="tool-card-description">{tool.description}</p>
      <div className="tool-card-tags">
        {tool.tags.slice(0, 3).map(tag => (
          <span key={tag} className="tool-card-tag">#{tag}</span>
        ))}
      </div>
      <span className="tool-card-arrow">→</span>
    </Link>
  );
};

export default ToolCard;
